module.exports = __webpack_public_path__ + "static/media/nurture.010582b8.svg";